/* eslint-disable no-bitwise */
export enum UserPrivilege2 {
  SuspendRM = 1 << (47 - 32),
  CannotSendTransfer = 1 << 3
}
